import ToggleSwitchStyled from "./ToggleSwitchStyled";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange }) => {
  const handleChange = () => {
    onChange(!checked);
  };

  return (
    <ToggleSwitchStyled>
      <label className="switch" aria-label="Toggle switch">
        <input type="checkbox" checked={checked} onChange={handleChange} />
        <span className="slider round" />
      </label>
    </ToggleSwitchStyled>
  );
};

ToggleSwitch.displayName = "ToggleSwitch";

export default ToggleSwitch;
